import ApiCore from "./api_core"
import { ModifyPersonI, NewPersonI, PersonI, PersonNameI } from "./types"

export default new class {
    all() {
        return ApiCore.getJson<NewPersonI>('people')
    }

    get(personId: number) {
        return ApiCore.getJson<PersonI>(`people/${personId}`)
    }

    create(person: NewPersonI) { 
        return ApiCore.postJson<PersonI>('people', person) 
    }

    update(personId: number, programID: number, person: ModifyPersonI) { 
        return ApiCore.putJson<PersonI>(`people/${personId}`, { ...person, program_id: programID })
    }

    getSimilarFamilyNames(name: string){
        return ApiCore.getJson<string[]>('search/family_name', { search_string: name})
    }

    getSimilarMiddleNames(name: string) {
        return ApiCore.getJson<string[]>('search/middle_name', { search_string: name})
    }

    getSimilarGivenNames(name: string) {
        return ApiCore.getJson<string[]>('search/given_name', { search_string: name})
    }

    getNames(personId: number) { 
        return ApiCore.getJson<PersonNameI>(`people/${personId}/names`) 
    }

    void(personId: number, reason: string) {
        return ApiCore.void('people/'+personId, { reason })
    }
}
